import config from "@Config/index";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { GROWTH_BOOK_FEATURE_FLAG_NAMES } from "constants/index";

const useApplyForFallExperiment = (roomData: Record<any, any>, inventory: Record<any, any>) => {
  const isApplyForFallExperiment = useFeatureIsOn(
    GROWTH_BOOK_FEATURE_FLAG_NAMES.APPLY_FOR_FALL_EXPERIMENT,
  );

  const isChina = config.IS_CHINA_APP;
  const isPBSA = inventory?.meta?.unit_type === "student_accommodation";

  const isFlexiRoom =
    roomData?.available &&
    (roomData.active_children_with_filters_count === 0 ||
      roomData?.active_children_with_filters.length === 0 ||
      roomData.active_children?.length === 0 ||
      roomData?.active_children_count === 0);

  if (isFlexiRoom) return false;

  const allTenanciesMoveIn =
    (roomData?.active_children || roomData?.active_children_with_filters)
      ?.map((item: any) => item?.meta?.available_from_formatted ?? "")
      .filter((val: string) => val !== "") || [];

  if (roomData?.available && allTenanciesMoveIn.length === 0) return false;

  const thresholdDate = new Date("31 Jul, 2026");
  const isThresholdDatePassed = allTenanciesMoveIn.some(
    (dateStr: string) => new Date(dateStr) > thresholdDate,
  );

  return (isApplyForFallExperiment || isChina) && isPBSA && !isThresholdDatePassed;
};

export default useApplyForFallExperiment;
